<template>
  <div>
    <Header />
    <container v-if="global_loading">
      <div class="spinner-border space-above-container primary-text-color" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </container>
    <div v-else>
      <b-row class="space-above">
        <b-col>
          <h2>{{this.user}}</h2>
        </b-col>
      </b-row>
      <b-row class="space-above">
        <b-col cols="1">
        </b-col>
        <b-col cols="9">
           <div v-for="(scripts, types) in user_scripts" :key="types" >
               <h2>Scripts</h2>
                <b-row style="background-color:#ADD8E6; margin:2px;min-height:60px; padding-top:13px">
                  <b-col cols="2">
                    <span><strong>Script</strong></span>
                  </b-col>
                  <b-col cols="2">
                    <span><strong>Script Name</strong></span>
                  </b-col>
                  <b-col cols="2">
                    <span><strong>Script Tag</strong></span>
                   </b-col>
                   <b-col cols="3">
                    <span><strong>Applicable Docker Images</strong></span>
                   </b-col>
                </b-row>
               <div v-for="script in scripts" :key="script.uuid">
                  <b-row style="background-color:#ADD8E6; margin:2px;min-height:60px; padding-top:13px">
                    <b-col cols="2">
                      <a href="#"><span>{{script.name}}</span></a>
                    </b-col>
                    <b-col cols="2">
                      <span>Name: {{script.name}}</span>
                    </b-col>
                    <b-col cols="2">
                      <span>Tag: {{script.tag}}</span>
                     </b-col>
                     <b-col cols="3">
                      <span>Docker: {{script.docker}}</span>
                     </b-col>
                     <b-col v-if="types==='success' || types==='error'" cols="1">
                        <b-button style="float:left" @click="edit_script(script.name)" type="submit">Edit</b-button>
                     </b-col>
                     <b-col v-if="types==='success' || types==='error'" cols="1">
                        <b-button style="float:left" @click="delete_cancel_script(script.uuid)" type="submit">Delete</b-button>
                     </b-col>
                     <b-col v-if="types==='running'" cols="1">
                        <b-button style="float:left" @click="delete_cancel_script(script.uuid)" type="submit">Cancel</b-button>
                     </b-col>
                  </b-row>
                </div>
           </div>

        </b-col>
        <b-col cols="1">
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import Header from './Header.vue';
  import axios from 'axios';
  import store from  '@/store/store';
  export default {
    name: 'User',
    components: {
      Header
    },
    data() {
      return {
        user: store.state.user["cognito:username"],
        items: [],
        tags: [],
        filtered_items: [],
        filtered_tag: '',
        search_item: {},
        search_items: [
          { name: 'python 11' },
          { name: 'postgres 11' },
          { name: 'mongodb 12' },
          { name: 'postgres 14' },
        ],
        user_scripts:{"success": [{"uuid":"abc", "name":"abc", "tag": "1", "docker": "latest"}]},
        applications: [],
        dockers: [],
        search_type: '',
        placeholder: "Search by Application",
        display_toggle: {},
        global_loading: false,
        nav_out: false
      }
    },
    // computed: {
    //   is_logged_in(){
    //     return store.state.id_token;
    //   }
    // },
    methods: {
      custom_search(search) {
        this.script = search;
        this.fetch_search();
      },
      fetch_search() {
        const url = "https://0n7ecdnf2l.execute-api.us-east-1.amazonaws.com/Prod/find_user_scripts?user="+this.user;
        axios.get(url, {
            headers: {
              Authorization: 'Bearer '+store.state.id_token
            }
        }).then(response=>{
            this.user_scripts = response['data'];
            if (this.user_scripts && this.user_scripts['running'] && this.user_scripts['running'].length && !this.nav_out){
                setTimeout(this.fetch_search, 5000);
            }
        })
      },
      edit_script(name){
          this.nav_out = true;
          console.log(name)
          this.$router.push({ name: 'Upsert', params: { script: name} });
      },
      delete_cancel_script(uuid){
        console.log(uuid);
        const data = {
          "uuid": uuid
        };
        axios.post("https://0n7ecdnf2l.execute-api.us-east-1.amazonaws.com/Prod/global_installer_delete", data,  
          {
            headers: {
                Authorization: 'Bearer '+store.state.id_token
            }
          });
      }
    },
    created(){
      const user = store.state.user["cognito:username"];
      if (!user){
          // location.replace("https://authentication.simtekz.com/login?client_id=3l505p8r7gtfsd4upctv22f6nh&response_type=token&scope=email+openid+phone&redirect_uri=https://simtekz.com");
      }
    },
    mounted() {
      this.fetch_search();  
    },
  }
</script>

<style scoped>
  .card {
    width: 100%;
    border-style: none;
  }

  .space-above-container {
    margin-top: 30px;
    text-align: center;
  }

  .space-above {
    margin-top: 60px;
    text-align: center;
  }

  .primary-text-color {
    color: #17a2b8;
  }

  .left-text-align {
    text-align: left;
    font-family: SFMono-Medium, "SF Mono", "Segoe UI Mono", "Roboto Mono", "Ubuntu Mono", Menlo, monospace;
  }

  .table-code {
    border: 1px solid #ddd;
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
  }

  td>pre {
    margin: 0px !important;
  }
</style>